import React from 'react';
import { useContractState } from '../context/ContractContext';
import { formatUSDT, formatDate } from '../utils/format';
import EmptyState from '../components/common/EmptyState';

const TYPES = {
  1: { name: 'Investment',   klass: 'invest',   icon: '↑' },
  2: { name: 'ROI Earned',   klass: 'roi',      icon: '%' },
  3: { name: 'Level Income', klass: 'level',    icon: 'L' },
  4: { name: 'Claim',        klass: 'claim',    icon: '$' },
  5: { name: 'Start Trade',  klass: 'trade',    icon: '⚡' },
  6: { name: 'Migrated',     klass: 'migrated', icon: 'M' }
};

export default function Activity() {
  const { activities = [] } = useContractState();
  return (
    <div className="page">
      <div className="page-title grad-text">Activity</div>
      <p className="page-subtitle">Latest events on your account.</p>
      {activities.length === 0
        ? <EmptyState icon="📜" title="No activity yet" msg="Once you invest and trade, everything appears here." />
        : activities.map((a, i) => {
            const t = TYPES[a.activityType] || { name: 'Event', klass: 'invest', icon: '·' };
            return (
              <div key={i} className="activity-item">
                <div className={`icon ${t.klass}`}>{t.icon}</div>
                <div className="info">
                  <div className="type">{t.name}</div>
                  <div className="time">{formatDate(a.timestamp)}</div>
                </div>
                <div className="amt">{formatUSDT(a.amount)}</div>
              </div>
            );
          })}
    </div>
  );
}
